import { Avatar, List, ListItem, ListItemAvatar, ListItemButton, ListItemIcon, ListItemText, Paper, Typography } from "@mui/material";
import React from "react";
import { useNavigate } from "react-router-dom";
import { TypeFrigorficos, TypePlantas } from "../../pages/home/interace/frigorifico.interface";
import NavigateNextIcon from '@mui/icons-material/NavigateNext';

import imageFrio from './images/iconodiac1.jpg'

type CardProps = {
    propsFrigorifico: TypeFrigorficos;
    propsPlanta: TypePlantas;

}

export const FrigorificoComponent: React.FC<CardProps> = ({propsPlanta, propsFrigorifico}) => {
    let navigate = useNavigate();
    return (
        <Paper
        elevation={4}
        sx={{
            borderRadius: 3,
            overflow: "hidden",
            mb: 2,
            p: 1,
        }}
        >
        <List disablePadding>
            <ListItem disablePadding>
            <ListItemButton
                onClick={() => navigate("/camaras", { state: {planta: propsPlanta, frio: propsFrigorifico }})}
                sx={{
                borderRadius: 2,
                "&:hover": {
                    backgroundColor: "primary.main",
                    color: "white",
                    "& .MuiAvatar-root": {
                    border: "2px solid white",
                    },
                    "& .MuiSvgIcon-root": {
                    color: "white",
                    },
                },
                }}
            >
                {/* Avatar del frigorífico */}
                <ListItemAvatar>
                <Avatar
                    alt="Frigorífico"
                    src={imageFrio}
                    sx={{ width: 48, height: 48, mr: 1 }}
                />
                </ListItemAvatar>

                {/* Texto principal */}
                <ListItemText
                primary={
                    <Typography variant="subtitle1" fontWeight="bold">
                    {propsFrigorifico.name_front}
                    </Typography>
                }
                secondary={
                    <Typography variant="body2" color="text.secondary">
                    {propsFrigorifico.ubicacion || "Ubicación desconocida"}
                    </Typography>
                }
                />

                {/* Icono de navegación */}
                <ListItemIcon sx={{ minWidth: 32 }}>
                <NavigateNextIcon />
                </ListItemIcon>
            </ListItemButton>
            </ListItem>
        </List>
        </Paper>
            )
}

